import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';

/** Supported Infographics types */
export enum InfographicsType {
  Battery = 'BATTERY',
  Memory = 'MEMORY',
  Storage = 'STORAGE',
}

@Component({
  selector: 'xs-device-infographics',
  templateUrl: './device-infographics.component.html',
  styleUrls: ['./device-infographics.component.scss'],
})
export class DeviceInfographicsComponent implements OnChanges {
  @Input() title: string;
  @Input() available: string;

  @Input() set total(value: string) {
    this.totalValue = isNaN(Number.parseInt(value, 10)) ? 0 : Number.parseInt(value, 10);
  }

  @Input() backColor: string;
  @Input() foreColor: string;
  @Input() isPercentage: boolean;
  @Input() isFormatted: boolean;
  @Input() icon: string;
  @Input() smallInfographics: boolean;

  radius = 22;
  circumference = 2 * Math.PI * this.radius;

  private totalValue: number;
  private value: number;
  private defaultValue: string;

  constructor(private saI18nPipe: XsI18nPipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.available) {
      this.value = isNaN(Number.parseInt(changes.available.currentValue, 10))
        ? 0
        : Number.parseInt(changes.available.currentValue, 10);
      this.defaultValue = Number.isNaN(Number.parseInt(changes.available.currentValue, 10))
        ? changes.available.currentValue
        : undefined;
    }
  }

  getIcon(): string {
    const icon = `hd-icon ${this.icon}`;
    return icon;
  }

  getStatus(): string {
    let result = '';
    const used = this.calcUsedValue();

    if (this.isPercentage || this.isFormatted) {
      if (this.defaultValue) {
        result = this.defaultValue;
      } else {
        result = !this.isFormatted ? this.available + ' %' : this.available;
      }
    } else {
      if (this.totalValue === 0) {
        result = this.calcSize(used) + '/' + this.saI18nPipe.transform('Snapshot_Unknown_Value');
      } else {
        result = this.calcSize(used) + '/' + this.calcSize(this.totalValue);
      }
    }

    return result;
  }

  calcPercentage(): number {
    const used = this.calcUsedValue();

    let temp = (used / this.totalValue) * 100;
    if (this.isPercentage) {
      temp = this.value;
    }
    const result = this.circumference - (temp * this.circumference) / 100;

    return Number(+result.toFixed(1));
  }

  private calcSize(sizeInBytes: number): string {
    const sizeInMB = sizeInBytes / (1024 * 1024);

    if (sizeInMB >= 1024) {
      return +(sizeInMB / 1024).toFixed(1) + ' GB';
    }
    return +sizeInMB.toFixed(1) + ' MB';
  }

  private calcUsedValue(): number {
    if (this.value > this.totalValue) {
      if (this.totalValue === 0) {
        return this.value;
      } else {
        return this.totalValue;
      }
    }
    return this.totalValue - this.value;
  }
}
